
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { QuestionDetail } from '@externalregistrationmodel/Registration';
import { environment } from '@environment/environment';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class ExternalForgotPasswordService {
  private baseUrl: string;
  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
  }

  // Method to get the Security Question list
  GetQuestion(): Observable<any[]> {
    return this.http.get(this.baseUrl + `/api/GetSecurityQuestion`).pipe(
      map(response => response as QuestionDetail[]),
      catchError(handleError),);
  }

  SubmitForgotPassword(userDetails: any): Observable<any[]> {
    debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/ForgotPassword`, JSON.stringify(userDetails), options).pipe(
      map(response => response as any),
      catchError(handleError),);
  }
}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);

  // throw an application level error
  return observableThrowError(errorMsg);
}
